<template>
  <div>
    <b-col sm="12">
      <b-input-group prepend="Nome" size="sm" class="mt-4">
        <b-form-input
          v-bind:value="name"
          v-on:input="(event) => this.$emit('update:name', event)"
          v-validate.initial="'required'"
          type="text"
          name="name"
          size="sm"
          :disabled="disabledInputs"
        />
      </b-input-group>
      <b-form-invalid-feedback :state="errors.collect('name').length === 0">{{errors.first('name')}}</b-form-invalid-feedback>
    </b-col>
    <b-col sm="12">
      <b-input-group prepend="Categoria" size="sm" class="mt-4">
        <b-form-input
          v-bind:value="mealCategory"
          v-on:input="(event) => this.$emit('update:mealCategory', event)"
          v-validate.initial="'required'"
          type="text"
          name="category"
          size="sm"
          :disabled="disabledInputs"
        />
      </b-input-group>
      <b-form-invalid-feedback
        :state="errors.collect('category').length === 0"
      >{{errors.first('category')}}</b-form-invalid-feedback>
    </b-col>
  </div>
</template>

<script>
export default {
  name: "translationsMeal",
  props: {
    name: {
      type: String,
      required: true
    },
    mealCategory: {
      type: String,
      required: true
    },
    disabledInputs: {
      type: Boolean,
      required: true
    }
  }
};
</script>